import { MODULES } from "./modules";

export const clientConfig = {
  clientName: "Default",
  modules: {
    [MODULES.AI_HUB]: true,
    [MODULES.CHAT]: true,
    [MODULES.KG_CHAT]: false,
    [MODULES.DOC_FINDER]: true,
    [MODULES.CONSISTENCY_GUARD]: true,
    [MODULES.NL2GRAPH]: false,
    [MODULES.QNA]: true,
    [MODULES.HISTORY]: true,
    [MODULES.ONBOARDING_COPILOT]: false,
    [MODULES.AI_ADOPTION]: true,
    [MODULES.DASHBOARD]: true,
    [MODULES.SETTINGS]: true,
    [MODULES.COMPLIANCE]: true,
    [MODULES.ADMIN_REPLY]: true,
    [MODULES.USAGE]: true,
    [MODULES.USERS]: true,
  },
};
